import script from "./promptHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./promptHistory.vue?vue&type=script&setup=true&lang=js"

import "./promptHistory.vue?vue&type=style&index=0&id=72292f9c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72292f9c"]])

export default __exports__